const STORAGE_KEY = "bochas_request_errors";
const MAX_ENTRIES = 50;

export function recordRequestError({ url, method = "GET", status = 0, code = "NETWORK_ERROR", retry = 0 }) {
  try {
    const endpoint = new URL(url || "/", window.location.origin).pathname;
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    const entries = Array.isArray(stored) ? stored : [];
    entries.push({
      time: new Date().toISOString(),
      endpoint,
      method: String(method).toUpperCase(),
      status,
      code,
      retry,
    });
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries.slice(-MAX_ENTRIES)));
  } catch (_) {
    // El diagnóstico no debe interferir con las solicitudes.
  }
}
